import { get, post, put } from 'api/methods';

import { Success } from 'api/interfaces';

import { ApiName } from 'enuns/Api';

export interface PerguntaResponse {
  cpfUsuario: string;
  dataPergunta: string;
  dataResposta: string;
  idPergunta: number;
  lido: boolean;
  pergunta: string;
  resposta: string;
  usuarioPergunta: string;
  destaque: boolean;
}

export type ListaPerguntas = PerguntaResponse[];

interface PerguntarPayload {
  pergunta: string;
  idAssembleia: number;
}

export default {
  listar: (idAssembleia: number) => {
    const endpoint = `pergunta/pergunta-assembleia`;
    return get<ListaPerguntas>(ApiName.Messenger, endpoint, {
      params: { idAssembleia },
    });
  },
  perguntar: (data: PerguntarPayload) => {
    const endpoint = 'pergunta/registra-pergunta';
    return post<PerguntaResponse>(ApiName.Messenger, endpoint, data);
  },
  lido: (idPergunta: number) => {
    const endpoint = `pergunta/${idPergunta}/lido`;
    return put<Success>(ApiName.Messenger, endpoint);
  },
};
